import React, { memo } from 'react';
import { cn } from '@/lib/utils';

interface PageContainerProps {
  children: React.ReactNode;
  rightSidebar?: React.ReactNode;
  className?: string;
}

export const PageContainer = memo<PageContainerProps>(({
  children,
  // rightSidebar intentionally ignored — ad sidebar globally hidden, will be re-enabled later.
  rightSidebar: _rightSidebar,
  className
}) => {
  return (
    <div
      className={cn(
        'grid gap-6 max-w-[1300px] mx-auto pt-0 pb-6 pl-6 pr-4',
        'grid-cols-[minmax(0,1fr)]',
        className
      )}
    >
      {children}
    </div>
  );
});

PageContainer.displayName = 'PageContainer';